import { computed } from 'vue';

export function useMessageReactions(messageRef, currentUserIdRef, reactionMap) {
    // 1. Tính toán summary chung
    const reactionSummary = computed(() => {
        const reactions = messageRef.value?.reactions || [];
        return reactions.reduce((acc, r) => {
            const key = r.emoji;
            if (!acc[key]) {
                acc[key] = { count: 0, icon: reactionMap[key], emoji: key };
            }
            acc[key].count++;
            return acc;
        }, {});
    });

    // 2. Tính tổng số lượt react
    const totalReactionCount = computed(() => {
        return Object.values(reactionSummary.value).reduce((acc, curr) => acc + curr.count, 0);
    });

    // 3. Lấy Top 2 emoji nhiều nhất (cho Reaction Pill)
    const topReactionEmojis = computed(() => {
        return Object.values(reactionSummary.value)
            .sort((a, b) => b.count - a.count)
            .slice(0, 2);
    });

    // 4. Lấy reaction mới nhất của chính mình (Own Reaction Bubble)
    const ownLatestReaction = computed(() => {
        const myReactions = (messageRef.value?.reactions || []).filter(r => r.userId === currentUserIdRef.value);
        if (myReactions.length === 0) return null;
        
        const latest = myReactions.reduce((prev, curr) => {
            return new Date(curr.createdAt || 0).getTime() >= new Date(prev.createdAt || 0).getTime() ? curr : prev;
        });
        return { icon: reactionMap[latest.emoji], emoji: latest.emoji };
    });

    return {
        reactionSummary,
        totalReactionCount,
        topReactionEmojis,
        ownLatestReaction
    };
}
